export enum ParameterKeyEnum {
  android_subscription_markdown = 'android_subscription_markdown',
  card_color = 'card_color',
  change_music_button = 'change_music_button',
  change_music_text = 'change_music_text',
  code_verefication_text = 'code_verefication_text',
  contact_info_text = 'contact_info_text',
  days_after_last_discount = 'days_after_last_discount',
  delete_account_button = 'delete_account_button',
  delete_account_description = 'delete_account_description',
  delete_account_title = 'delete_account_title',
  enable_website_subscription_email = 'enable_website_subscription_email',
  feedback_email = 'feedback_email',
  free_titles_popup_duration = 'free_titles_popup_duration',
  free_titles_popup_markdown = 'free_titles_popup_markdown',
  free_titles_popup_title = 'free_titles_popup_title',
  header_font_size = 'header_font_size',
  header_text = 'header_text',
  iap_subscription_upgrade_text = 'iap_subscription_upgrade_text',
  iap_subscription_upgrade_title = 'iap_subscription_upgrade_title',
  ios_subscription_markdown = 'ios_subscription_markdown',
  login_after_iap_description = 'login_after_iap_description',
  login_after_iap_header = 'login_after_iap_header',
  login_confirmation_text = 'login_confirmation_text',
  login_text = 'login_text',
  manage_subscriptions_text = 'manage_subscriptions_text',
  my_collection_remove_description = 'my_collection_remove_description',
  my_collection_remove_header = 'my_collection_remove_header',
  onboarding_description_slide_1 = 'onboarding_description_slide_1',
  onboarding_description_slide_2 = 'onboarding_description_slide_2',
  onboarding_description_slide_3 = 'onboarding_description_slide_3',
  onboarding_description_slide_4 = 'onboarding_description_slide_4',
  onboarding_description_slide_5 = 'onboarding_description_slide_5',
  onboarding_text_slide_1 = 'onboarding_text_slide_1',
  onboarding_text_slide_2 = 'onboarding_text_slide_2',
  onboarding_text_slide_3 = 'onboarding_text_slide_3',
  onboarding_text_slide_4 = 'onboarding_text_slide_4',
  onboarding_text_slide_5 = 'onboarding_text_slide_5',
  padlock_icon = 'padlock_icon',
  player_intro_description = 'player_intro_description',
  player_intro_header = 'player_intro_header',
  purchase_text = 'purchase_text',
  redirection_email = 'redirection_email',
  show_promo = 'show_promo',
  show_tutorial = 'show_tutorial',
  subscription_reminder_text = 'subscription_reminder_text',
  subscription_reminder_title = 'subscription_reminder_title',
  tips_array_colour = 'tips_array_colour',
  tips_array_font_size = 'tips_array_font_size',
  tips_array_step_duration_hours = 'tips_array_step_duration_hours',
  tips_array_text = 'tips_array_text',
  url_privacy = 'url_privacy',
  url_terms = 'url_terms',
  website_subscription_all_titles_text = 'website_subscription_all_titles_text',
  website_subscription_all_titles_title = 'website_subscription_all_titles_title',
  website_subscription_upgrade_text = 'website_subscription_upgrade_text',
  website_subscription_upgrade_title = 'website_subscription_upgrade_title',
}
